module.exports = __webpack_public_path__ + "img/1525265839.34dee5b3.jpg";